export function createFieldName(field: Field) {
  const { group, name } = field;

  if (group) {
    return `${group}[${name}]`;
  }

  return name;
}

export function parseFormStringToArray(str) {
  const regex = /^(.*?)\[(.*?)\]$/;
  const matches = regex.exec(str);

  if (!matches) return [str];

  const initialString = matches[1];
  const insideSquareBrackets = matches[2];

  const result = insideSquareBrackets.split(/\[|\]/).filter(Boolean);

  result.unshift(initialString);

  return result;
}

export function accessFormFieldValue(
  definition: Field,
  formValue: any,
  getFullOption = false,
): any {
  return accessFormFieldValueByName(
    createFieldName(definition),
    formValue,
    getFullOption,
  );
}

export function accessFormFieldValueByName(
  name: string,
  formValue: any,
  getFullOption = false,
): any {
  const steps = parseFormStringToArray(name);

  let actualValue = JSON.parse(JSON.stringify(formValue));

  for (const step of steps) {
    actualValue = ![null, undefined].includes(actualValue)
      ? actualValue[step]
      : null;
  }

  if (![null, undefined].includes(actualValue)) {
    return actualValue.hasOwnProperty("value") && !getFullOption
      ? actualValue.value
      : actualValue;
  }

  return null;
}
